import React, { useState } from 'react';
import {
  TiSocialFacebook,
  TiSocialLinkedin,
  TiSocialTwitter,
  TiSocialYoutube,
  TiSocialInstagram,
} from 'react-icons/ti';
import { RiSendPlaneFill } from 'react-icons/ri';
import '../styles/footer.css';
import { baseUrl } from '../config';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setIsSubmitted(false);

    if (!email) {
      setErrorMessage('Please enter a valid email.');
      return;
    }

    if (!validateEmail(email)) {
      setErrorMessage('Please enter a valid email format.');
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch(`${baseUrl}/newsletter`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setIsSubmitted(true);
        setEmail('');
      } else {
        const errorResponse = await response.json();
        setErrorMessage(errorResponse.detail || 'Failed to submit. Please try again.');
      }
    } catch (error) {
      setErrorMessage('An error occurred. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-about">
          <h4><b>Producer Buddy</b></h4>
          <p>Changing the way you experience Film making with AI-powered innovations.</p>
        </div>

        <div className="footer-sections">
          <div className="footer-section">
            <h4><a href="#aboutus">Producer Buddy</a></h4>
            <ul>
              <li><a href="/aboutus">About Us</a></li>
              <li><a href="#Technology">Technology</a></li>
              <li><a href="#Team">Team</a></li>
              <li><a href="/careers">Careers</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Resources</h4>
            <ul>
              <li><a href="/blog">Blog</a></li>
              <li><a href="/Ebook">Ebook</a></li>
              <li><a href="/Comunity">Community</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4><a href="/contactus">Contact Us</a></h4>
            <ul>
              <li><a href="mailto:contact@pilomation.com">contact@pilomation.com</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Social Media</h4>
            <ul className="social-media-links">
              <li><a href="https://www.facebook.com/profile.php?id=61562671923171" target="_blank" rel="noopener noreferrer"><TiSocialFacebook /></a></li>
              <li><a href="https://x.com/pilomation" target="_blank" rel="noopener noreferrer"><TiSocialTwitter /></a></li>
              <li><a href="https://www.instagram.com/pilomation/" target="_blank" rel="noopener noreferrer"><TiSocialInstagram /></a></li>
              <li><a href="https://www.linkedin.com/company/pilomation/" target="_blank" rel="noopener noreferrer"><TiSocialLinkedin /></a></li>
              <li><a href="https://www.youtube.com/@Pilomation" target="_blank" rel="noopener noreferrer"><TiSocialYoutube /></a></li>
            </ul>
          </div>
        </div>

        <div className="newsletter-container">
          <div className="newsletter-section">
            <h4>Subscribe to our Newsletter</h4>
            <form className="newsletter-form" onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isLoading}
                className={errorMessage ? 'input-error' : ''}
              />
              <button type="submit" disabled={isLoading}>
                {isLoading ? 'Submitting...' : <RiSendPlaneFill />}
              </button>
            </form>
            {isSubmitted && <p className="success-message">Thank you for subscribing!</p>}
            {errorMessage && <p className="error-message">{errorMessage}</p>}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} Powered by{' '}
          <a href="https://pilomation.com" target="_blank" rel="noopener noreferrer">Pilomation</a>
          . All rights reserved.{' '}
          <a href="/policy">Privacy Policy</a> | <a href="/terms">Terms &amp; Conditions</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
